// extracted by mini-css-extract-plugin
export default {"logos":"m4Ckbi98KY7NypWjlkG1fg==","logo":"_7k85bBxrzE+nv2FW3b76ug=="};